import { useEffect as e } from "react";
import { updateLinkColors as f } from "./utils/update-link-colors.mjs";
const u = (r, t) => {
  e(() => {
    r && t && f(r, t);
  }, [t, r]);
};
export {
  u as useUpdateLinkColor
};
